exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./StdKaiXHYL5EG-Md.eot"));
var ___CSS_LOADER_URL___1___ = urlEscape(require("./StdKaiXHYL5EG-Md.eot") + "?#iefix");
var ___CSS_LOADER_URL___2___ = urlEscape(require("./StdKaiXHYL5EG-Md.woff2"));
var ___CSS_LOADER_URL___3___ = urlEscape(require("./StdKaiXHYL5EG-Md.ttf"));
var ___CSS_LOADER_URL___4___ = urlEscape(require("./StdKaiXHYL5EG-Md.svg") + "#StdKaiXHYL5EG-Md");

// Module
exports.push([module.id, "@font-face {\n    font-family: \"StdKaiXHYL5EG-Md\";\n    src: url(" + ___CSS_LOADER_URL___0___ + "); /* IE9 */\n    src: url(" + ___CSS_LOADER_URL___1___ + ") format(\"embedded-opentype\"), \n    url(" + ___CSS_LOADER_URL___2___ + ") format(\"woff2\"), \n    url(" + ___CSS_LOADER_URL___3___ + ") format(\"truetype\"), \n    url(" + ___CSS_LOADER_URL___4___ + ") format(\"svg\"); /* iOS 4.1- */\n    font-style: normal;\n    font-weight: normal;\n}\n\n\n", ""]);

